import { useEffect, useState } from "react";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";
import api from "@/lib/api";

export default function ActivityTrail() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/activity-trail?limit=300").then((r) => setRows(r.data)); }, []);
  return (
    <PortalLayout title="Activity Trail">
      <p className="text-sm text-muted-foreground mb-6">Immutable audit log of every significant platform action.</p>
      <GlassCard className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-audit-log-table">
            <thead>
              <tr className="text-left pdg-kicker border-b border-border">
                <th className="px-5 py-3 font-normal">Action</th>
                <th className="px-5 py-3 font-normal">User</th>
                <th className="px-5 py-3 font-normal">IP</th>
                <th className="px-5 py-3 font-normal">Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid="admin-audit-log-row" className="border-b border-border hover:bg-[hsl(var(--pdg-elevated)/0.35)] transition-colors">
                  <td className="px-5 py-3 text-foreground">{r.action}</td>
                  <td className="px-5 py-3 text-muted-foreground">{r.user_email || "—"}</td>
                  <td className="px-5 py-3 pdg-mono text-xs text-muted-foreground">{r.ip}</td>
                  <td className="px-5 py-3 pdg-mono text-xs text-muted-foreground">{new Date(r.timestamp).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <p className="p-6 text-sm text-muted-foreground">No activity recorded.</p>}
        </div>
      </GlassCard>
    </PortalLayout>
  );
}
